__turbopack_context__.v({
  "container": "HorizontalSlider-module-scss-module__R88Yba__container",
  "containerAuto": "HorizontalSlider-module-scss-module__R88Yba__containerAuto",
  "slide": "HorizontalSlider-module-scss-module__R88Yba__slide",
});
